<template>
    <div id="app" :class="theme">
        <Header></Header>
        <router-view :key="$route.path"></router-view>
        <Newsletter></Newsletter>
        <TreineBanners area="footer"></TreineBanners>
        <TreineBanners area="subfooter"></TreineBanners>
        <Footer></Footer>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Newsletter from "@/components/Newsletter";

import Header from "@/components/Header";
import TreineBanners from "@/components/TreineBanners";
import Footer from "@/components/Footer";

export default {
    name: "App",
    components: { TreineBanners, Footer, Header, Newsletter },
    methods: {
        ...mapActions({
            getWorkouts: "getWorkouts",
            getBanners: "getBanners",
            getVideos: "getVideos"
        })
    },
    data() {
        return {
            activeMenu: false
        };
    },
    computed: {
        ...mapGetters(["theme"])
    },
    created() {
        this.getWorkouts();
        this.getBanners();
        this.getVideos();
    }
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";

#app {
    overflow-x: hidden;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
}

body.menu-open {
    overflow: hidden;
}
</style>
